import { Outlet } from "react-router-dom-v5-compat";

export const BustleLayout = () => {
  return (
    <div className="h-full min-h-screen bg-bustle-pink-icing px-16 py-32 text-bustle-chalkboard md:px-32">
      <Outlet />
    </div>
  );
};
